import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ContactIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iframeMouseOver: false,
      submitted: false,
      pointerEvents: 'auto'
    };
    this.iframe = React.createRef();
  }
  componentDidMount() {
    this.iframe.current.addEventListener('load', () => {
      this.props.onLoad();
    });
    window.addEventListener('message', this.handleIframeTask);
  }
  componentWillUnmount() {
    this.iframe.current.removeEventListener('load', this.props.onLoad);
    window.removeEventListener('message', this.handleIframeTask);
  }

  handleIframeTask = e => {
    
    if (e.data === 'submitted form') {
      this.setState(
        {
          pointerEvents: 'none'
        },
        () => {
          this.props.hideHeading();
        }
      );
    }else{
      this.setState({pointerEvents: 'auto'})
    }
  };

  render() {
    return (
      <iframe
        id="c9-iframe"
        ref={this.iframe}
        src={this.props.src}
        width="100%"
        type="text/html"
        frameBorder="0"
        allowtransparency="true"
        title="contactForm"
        style={{ pointerEvents: this.state.pointerEvents }}
      />
    );
  }
}

export default ContactIframe;

ContactIframe.defaultProps = {
  src: '',
  onLoad: () => {},
  showHeading: () => {}
};

ContactIframe.propTypes = {
  src: PropTypes.string,
  onLoad: PropTypes.func,
  hideHeading: PropTypes.func
};
